import {Component, OnDestroy, OnInit} from '@angular/core';
import {Subscription} from 'rxjs';
import {ActivatedRoute, Params, Router} from '@angular/router';
import {OrganizationData} from '../../shared/types/organization/organization';
import {OrganizationRestService} from '../../shared/services/oganization/organization-rest.service';
import {FileRestService} from '../../shared/services/common/file/file-rest.service';
import {FileUtilsService} from '../../shared/services/common/file/file-utils.service';
import {AppointeeData} from '../../shared/types/appointment/appointee-data';
import {TranslateService} from '@ngx-translate/core';
import {OrganizationUpcomingEventsRestService} from '../../shared/services/oganization/organization-upcoming-events-rest.service';
import {UpcomingEvents} from '../../shared/types/organization/upcoming-events';
import {ConfirmationService} from 'primeng/api';
import {SecurityService} from '../../shared/services/security/security.service';
import {Editable} from '../../shared/types/security/editable';
import {SecurityRestService} from '../../shared/services/security/security-rest.service';
import {FileType} from '../../shared/types/file/file-type';
import {Location} from '@angular/common';
import {ContactData} from '../../shared/types/organization/contact-data';
import {ContactVisibility} from '../../shared/types/contact/contact-visibility';
import {Person} from '../../shared/types/person/person';
import {User} from '../../shared/types/security/user';
import {PersonRestService} from '../../shared/services/person/person-rest.service';

@Component({
  selector: 'wsd-organization-detail',
  templateUrl: './organization-detail.component.html',
  styleUrls: ['./organization-detail.component.css']
})
export class OrganizationDetailComponent implements OnInit, OnDestroy {

  organization: OrganizationData;

  upcomingEvents: UpcomingEvents[];

  imageSrc: any;

  private routeSub: Subscription;

  isAuthenticated: boolean;

  editable: boolean;

  organizationNotFound: boolean = false;

  deleteable: boolean;

  user: User;

  loggedUser: Person;

  constructor(private organizationRestService: OrganizationRestService,
              private personRestService: PersonRestService,
              private fileRestService: FileRestService,
              private confirmService: ConfirmationService,
              private translate: TranslateService,
              private fileUtilsService: FileUtilsService,
              private upcomingEventsRestService: OrganizationUpcomingEventsRestService,
              private route: ActivatedRoute,
              private router: Router,
              private location: Location,
              private securityService: SecurityService,
              private securityRestService: SecurityRestService) {
  }

  ngOnInit() {
    this.routeSub = this.route.params.subscribe(
      (params: Params) => this.loadOrganization(params)
    );
    this.securityService.isAuthenticated().subscribe(value => {
      this.isAuthenticated = value;
    });
    this.securityRestService.getCurrentUser().subscribe((user: User) => {
        this.user = user;
        if (this.user.consultantId) {
          this.personRestService.getPersonFromAllPersons(this.user.consultantId).subscribe((loggedPerson: Person) => {
            this.loggedUser = loggedPerson;
          });
        }
      }
    );
  }

  private loadOrganization(params: Params) {
    if (params['id']) {
      this.organizationRestService.getAllOrganizationData(+params['id']).subscribe(
        (data: OrganizationData) => {
          this.organization = data;
          this.loadLogo();
          if (this.organization.scoutOrgId !== null) {
            this.loadUpcomingEvents(this.organization.scoutOrgId);
          }
        },
        () => {
          console.log('Nieco nem dobre');
          this.organizationNotFound = true;
        }

      );
      this.securityRestService.getEditableOrganization(+params['id']).subscribe(
        (data: Editable) => {
          this.editable = data.editable;
          this.deleteable = data.deletable;
        }
      );
    }
  }

  private loadLogo() {
    const logo = this.organization.fileInfo
      .filter(Boolean)
      .find(file => file.type === FileType.ORGANIZATION);
    if (logo) {
      this.loadImage(logo.id);
    }
  }

  private loadUpcomingEvents(scoutOrgId: number) {

    this.upcomingEventsRestService.getAllUpcomingEvents(scoutOrgId, Math.ceil(new Date().getTime() / 1000)).subscribe(
      (data: UpcomingEvents[]) => {
        this.upcomingEvents = data;
      }
    );
  }

  private loadImage(imgId: number) {
    if (!imgId) {
      return;
    }
    this.fileRestService.getImage(imgId.toString()).subscribe(
      ((data: any) => {
        this.imageSrc = this.fileUtilsService.getImage(data.content);
      })
    );
  }

  getFullName(appointee: AppointeeData): string {
    let name: string = '';
    if (appointee.consultant.firstName) {
      name = appointee.consultant.firstName + ' ';
    }
    if (appointee.consultant.lastName) {
      name += appointee.consultant.lastName;
    }
    return name;
  }

  getWagggsValue() {
    return [
      this.translate.instant('WS_DIRECTORY.' + (this.organization.wagggsMember ? 'YES' : 'NO')),
      this.organization.wagggsDescription
    ].filter(Boolean).join(' - ');
  }

  delete() {
    this.confirmService.confirm({
      header: this.translate.instant('WS_DIRECTORY.ORG_DETAIL.DELETE_CONFIRM_HEADER'),
      message: this.translate.instant('WS_DIRECTORY.ORG_DETAIL.DELETE_CONFIRM_MESSAGE'),
      accept: () => {
        this.organizationRestService.deleteOrganization(this.organization.id).subscribe(next => {
          this.router.navigate(['/contacts']);
        });
      }
    });
  }

  goBack() {
    this.location.back();
  }

  ngOnDestroy(): void {
    if (this.routeSub) {
      this.routeSub.unsubscribe();
    }
  }

  showContact(contact: ContactData): boolean {

    if (contact.visibleInDirectory === ContactVisibility.VISIBLE_TO_WORLD_BUREAU_STAFF_AND_USERS) {
      return true;
    }

    if (this.loggedUser != null) {
      for (const i in this.loggedUser.roles) {
        const role = this.loggedUser.roles[i].roleName;

        if (role === "ROLE_WSD_STAFF" || role === "ROLE_WSD_REGIONAL_GROUP_ADMIN" || role === "ROLE_WSD_WORLD_GROUP_ADMIN") {
          return true;
        }

        if (contact.visibleInDirectory === ContactVisibility.VISIBLE_TO_WORLD_BUREAU_STAFF && role === 'ROLE_WSD_NSO_GROUP_ADMIN') {
          if (this.organization.name === this.loggedUser.organization.name) {
            return true;
          }
        }

        if ((contact.visibleInDirectory === ContactVisibility.VISIBLE_TO_WORLD_BUREAU_STAFF_AND_USERS_FROM_REGION)
          && (role === 'ROLE_WSD_INTRANET' || role === 'ROLE_WSD_NSO_GROUP_ADMIN' || role === 'ROLE_WSD_WORLD_COMMITTEES')) {
          if (this.organization.region.name === this.loggedUser.region.name) {
            return true;
          }
        }
      }
    }
    return false;
  }
}
